export const pvEvent = (config) => {
  LXAnalytics('pageView', {
    projectName: `${_KIT_PROJECT_NAME}`,
    ...config.valLab
  }, {
    isBeta: `${_ENVIRONMENT}` !== 'product',
  }, config.cid);// 从配置平台获取的页面 cid
}

export const meEvent = (bid) => {
  LXAnalytics('moduleEdit', bid);
}

export const mcEvent = (bid) => {
  LXAnalytics('moduleClick', bid);
}

export const mvEventWithConfig = (config) => {
  LXAnalytics('moduleView', config.bid, config.valLab, config.options);
}

export const meEventWithConfig = (config) => {
  LXAnalytics('moduleEdit', config.bid, config.valLab, config.options);
}

export const mcEventWithConfig = (config) => {
  LXAnalytics('moduleClick', config.bid, config.valLab, config.options);
}
